module.exports = __webpack_public_path__ + "img/36_51.235ceef2.png";